import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

// CSS Imports for libraries
import "react-quill/dist/quill.snow.css";
import "jsvectormap/dist/css/jsvectormap.css";
import "react-toastify/dist/ReactToastify.css";
import "react-modal-video/css/modal-video.min.css";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
// Main App component
const App = React.lazy(() => import.meta.env.MODE === 'uat'
  ? import('./UatApp.jsx')
  : import('./App.jsx'));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <React.Suspense fallback={null}><App /></React.Suspense>
    </HelmetProvider>
  </React.StrictMode>
);
